/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import { Button, Typography, TextField } from '@material-ui/core';
import styled from '@emotion/styled';
import { useHistory, useLocation, Redirect } from 'react-router-dom';
import { Formik } from 'formik';
import { useRootStore } from '../../stores/BridgeProvider';
import { StyledForm, WideBox, FlexDiv, ButtonFlex } from '../styles/styles';
import Spinner from '../util/Spinner';
import {
  formFieldGenerator,
  initialValueGenerator,
} from '../util/TemplateUtils';
import { DealTemplateSchema } from '../../validation';
import {
  RentStandardJSON,
  RentDetailedJSON,
  RentTwoTenantsJSON,
  SaleStandardJSON,
} from './DealTempTemplates';

const InputItem = styled.div`
  p {
    text-align: left;
    margin-bottom: 0px;
  }
  margin-bottom: 1rem;
  width: 100%;
`;
const types = {
  '#': 'wizard',
};

const getVariableToReplace = placeholder => {
  if (typeof placeholder === 'string') {
    const [symbol, variable] = [
      placeholder.substring(0, 1),
      placeholder.substring(1),
    ];
    const type = types[symbol];
    if (type) return [variable, type];
  }
  return false;
};

const templateMap = {
  rentStandard: RentStandardJSON,
  rentDetailed: RentDetailedJSON,
  rentTwoTenants: RentTwoTenantsJSON,
  saleStandard: SaleStandardJSON,
};

const TemplateWizard = () => {
  const history = useHistory();
  const { authStore } = useRootStore();
  const { state } = useLocation();
  const { templateId } = state || {};
  const dealTemplate = templateMap[templateId];

  if (!dealTemplate) return <Redirect to="/deal-templates/new" />;

  const {
    wizardDescription,
    wizardName,
    template,
    wizard,
    items,
  } = dealTemplate;
  const initialValues = {
    name: '',
    description: '',
    ...initialValueGenerator(wizard),
  };
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={DealTemplateSchema([
        ...wizard,
        { name: 'name', type: 'string', required: 'true' },
      ])}
      onSubmit={async (values, { resetForm, setSubmitting }) => {
        try {
          const { Deals, DealTransactions } = template;
          DealTransactions.forEach(dT => {
            Object.entries(dT).forEach(([key, value]) => {
              try {
                const splitVals = value.toString().split(' ');
                const replacedResult = splitVals.reduce((acc, val) => {
                  const variableToReplace = getVariableToReplace(val);
                  if (variableToReplace) {
                    const [variable, type] = variableToReplace;
                    // TODO: respond to type
                    return acc.length === 0
                      ? values[variable]
                      : `${acc} ${values[variable]}`;
                  }
                  return acc.length === 0 ? val : `${acc} ${val}`;
                }, '');

                dT[key] = replacedResult;
              } catch (e) {
                console.error(e);
              }
            });
          });
          // console.log(DealTransactions);
          const newTemplate = {
            items,
            template: {
              Deals,
              DealTransactions,
            },
          };
          console.log(newTemplate);

          const DT_FORMATTED = JSON.stringify(newTemplate);
          const { data } = await authStore.request.post(
            `${process.env.REACT_APP_API}/api/deal-template`,
            {
              Template: DT_FORMATTED,
              Name: values.name,
              Description: values.description,
            },
          );

          history.push(`/deal-template/${data.id}`);
          resetForm();
        } catch (e) {
          console.error(e);
        }
        setSubmitting(false);
      }}
      render={formikProps => {
        const {
          handleSubmit,
          isSubmitting,
          isValid,
          handleChange,
          handleBlur,
          values,
        } = formikProps;
        return (
          <FlexDiv>
            <WideBox style={{ minWidth: '700px' }}>
              <StyledForm onSubmit={handleSubmit}>
                <Typography variant="h2" gutterBottom>
                  {wizardName}
                </Typography>
                <Typography variant="h4" gutterBottom>
                  {wizardDescription}
                </Typography>
                <InputItem>
                  <p>Name for your template</p>
                  <TextField
                    label="Template Name"
                    name="name"
                    margin="normal"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.name}
                    variant="outlined"
                    fullWidth
                  />
                </InputItem>
                <InputItem>
                  <p>Description for your template (optional)</p>
                  <TextField
                    label="Description"
                    name="description"
                    margin="normal"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.description}
                    variant="outlined"
                    fullWidth
                  />
                </InputItem>
                {wizard.map((fieldObj, i) => (
                  <InputItem key={i}>
                    <p>{fieldObj.prompt}</p>
                    {formFieldGenerator({ fieldObj, formikProps, index: i })}
                  </InputItem>
                ))}
                <ButtonFlex>
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    size="large"
                    style={{ marginTop: '1.2rem', marginBottom: '1.2rem' }}
                    disabled={!isValid || isSubmitting}
                  >
                    Submit
                  </Button>
                  <Button
                    color="secondary"
                    variant="outlined"
                    style={{ marginTop: '1.2rem', marginBottom: '1.2rem' }}
                    onClick={() => history.goBack()}
                  >
                    Cancel
                  </Button>
                </ButtonFlex>
              </StyledForm>
            </WideBox>
          </FlexDiv>
        );
      }}
    />
  );
};

export default TemplateWizard;
